/* eslint-disable max-len */
import { useMemo, useState, useEffect, useContext } from "react";
import { useScreenClass } from "react-grid-system";
import { useParams } from "react-router-dom";
import { FlexGrow } from "../../components/FlexBox";
import { NullStateText } from "../../components/Text";
import axios from "axios";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarNavigator from "../../components/PillarNavigator";
import { CustomFlex } from "./ModifyPillarDetail";
import PillarSubdomainModify from "../../components/PillarSubdomainModify";
import LoadingSpinner from "../../components/LoadingSpinner";
import SnackBar from "../../components/SnackBar";
import { VersionContext } from "../../context/VersionContext";
interface CourseColumn {
  id: "title" | "number" | "pillar" | "competencies";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
// const courseColumns: readonly CourseColumn[] = [
//   { id: "title", label: "Course Title", minWidth: 200 },
//   {
//     id: "number",
//     label: "Course Number",
//     minWidth: 150,
//   },
//   { id: "pillar", label: "Pillar", minWidth: 80 },

//   {
//     id: "competencies",
//     label: "Competencies",
//     minWidth: 250,
//   },
// ];
function ModifySubdomainDetail(this: any) {
  const { pillarId, subdomainId } = useParams();
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [subdomainDetail, setSubdomainDetail] = useState<{
    id: string;
    description: string;
    title: string;
  } | null>({ id: "", description: "", title: "" });
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  useEffect(() => {
    if (pillarId && subdomainId) {
      fetchSubdomain(pillarId, subdomainId);
    }
  }, []);
  console.log(subdomainDetail);
  const { version } = useContext(VersionContext);

  const fetchSubdomain = (pillar_id: string, subdomain_id: string) => {
    axios
      .get(
        `/subdomain/summary?pillar_id=${pillarId}&subdomain_id=${subdomainId}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        axios
          .get(`/pillar?curriculum_version=${version.version_number}`)
          .then((res1) => {
            if (res.data.subdomain) {
              console.log(res);
              setSubdomainDetail(res.data.subdomains[0]);
            } else {
              setSubdomainDetail(null);
            }
            setPillarNavigation({
              ...pillarNavigation,
              id: pillar_id,
              title: res1.data.pillars.find((v: any) => v.id === pillar_id)
                .title,
              subdomains: {
                ...pillarNavigation.subdomains,
                id: res.data.subdomains[0].id,
                description: res.data.subdomains[0].description,
                title: res.data.subdomains[0].title,
              },
            });
          })
          .catch(() => {});
        // console.log(res)
      })
      .catch(() => {});
  };

  const updateSubdomainData = (data: any) => {
    // setLoading(true);
    axios
      .put("/subdomain/update", { ...data, id: subdomainId })
      .then((res) => {
        setMessage("Updated subdomain successfully");
        setIsSnackbarOpen(true);
        fetchSubdomain(pillarId || "", subdomainId || "");
        setLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to update subdomain!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  console.log("detaio", subdomainDetail);
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      {subdomainDetail?.id === "" ? (
        <LoadingSpinner />
      ) : (
        <CustomFlex
          style={{
            minHeight: "inherit",
            height: "100%",
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
            padding: 0,
          }}
        >
          <FlexGrow
            className="visible-scrollbar"
            style={{
              overflowX: "auto",
              maxHeight: "calc(100vh - 90px)",
              minHeight: "calc(100vh - 90px)",
            }}
          >
            <CustomFlex>
              <FlexGrow>
                <PillarNavigator path={pillarNavigation} />
              </FlexGrow>
            </CustomFlex>
            {/* {loading && <LoadingSpinner />} */}
            <PillarSubdomainModify
              subdomainData={subdomainDetail}
              goBack={() => {}}
              onSaveComplete={(data) => {
                updateSubdomainData(data);
              }}
            />
          </FlexGrow>
        </CustomFlex>
      )}
    </>
  );
}
export default ModifySubdomainDetail;
